<template>
  <div class="d-flex justify-end user-actions-wrapper align-center">
    <layout-user-actions-send-homework v-if="showHomeworkButton" />
    <Teleport :to="presentationStore.teacherToolsTarget ?? 'body'" :disabled="!presentationStore.open || !presentationStore.teacherToolsTarget">
      <layout-user-actions-teacher-tools v-if="!$vuetify.display.xs" />
    </Teleport>
    <layout-user-actions-profile-menu />
  </div>
</template>

<script lang="ts">
import constants from "~/constants"
import { usePresentationStore } from "~/stores/presentationStore"
import { useUserStore } from "~/stores/userStore"
import { anyPatternMatches } from "~/utils/pathMatch"

export default {
  setup() {
    const userStore = useUserStore()
    const presentationStore = usePresentationStore()
    return { userStore, presentationStore }
  },

  computed: {
    showHomeworkButton(): boolean {
      const showBasedOnRoute = anyPatternMatches(this.$route.path, constants.HOMEWORK_BUTTON_PATHS)
      return (
        !this.$vuetify.display.xs &&
        showBasedOnRoute &&
        this.userStore.isTeacher &&
        this.userStore.isEklaseUser
      )
    },
  },
}
</script>

<style lang="sass">
.user-actions-wrapper
  gap: 24px
</style>
